import { useEffect, useState } from 'react';

const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
const validVideoTypes = ['video/mp4', 'video/webm', 'video/quicktime', 'video/x-m4v'];

const useAttachments = ({ editingNote, maxFileSize }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileError, setFileError] = useState('');
    const [existingFiles, setExistingFiles] = useState(editingNote?.media || []);
    const [filesToDelete, setFilesToDelete] = useState([]);

    useEffect(() => {
        if (editingNote) {
            setExistingFiles(editingNote?.media || []);
        }
    }, [editingNote]);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            if (file.size > maxFileSize) {
                invalidFiles.push(`${file.name} (file too large)`);
            } else if (![...validImageTypes, ...validVideoTypes].includes(file.type.toLowerCase())) {
                invalidFiles.push(`${file.name} (only images/videos allowed: jpg, jpeg, png, gif, webp, mp4, webm, mov)`);
            } else {
                validFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            setFileError(`Some files were not added: ${invalidFiles.join(', ')}`);
        } else {
            setFileError('');
        }

        if (validFiles.length > 0) {
            setSelectedFiles(prevFiles => [...prevFiles, ...validFiles]);
        }

        e.target.value = null;
    };

    const removeFile = (index) => {
        setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    const toggleDeleteFile = (fileId) => {
        if (filesToDelete.includes(fileId)) {
            setFilesToDelete(filesToDelete.filter(id => id !== fileId));
        } else {
            setFilesToDelete([...filesToDelete, fileId]);
        }
    };

    const clearNewFiles = () => {
        setSelectedFiles([]);
    };

    const clearExistingFiles = () => {
        setExistingFiles([]);
        setFilesToDelete([]);
    };

    return {
        selectedFiles,
        setSelectedFiles,
        fileError,
        setFileError,
        existingFiles,
        setExistingFiles,
        filesToDelete,
        setFilesToDelete,
        handleFileChange,
        removeFile,
        toggleDeleteFile,
        clearNewFiles,
        clearExistingFiles,
    };
};

export default useAttachments;
